import { useMediaQueryHelper } from 'utils/hooks/useMediaQueryHelper'
import { useTogglesStore } from 'stores/toggles'

/**
 * Generic toggle-gated desktop view hook.
 * Combines viewport detection with Toggle SDK feature gating.
 *
 * - false (default): always renders mobile layout
 * - true: uses actual viewport — desktop layout activates at >=768px
 *
 * Usage:
 *   export const useMyFeatureDesktopView = () =>
 *     useDesktopView('my-feature-desktop-view-enabled')
 */
export const useDesktopView = (toggleKey: string) => {
  const { isDesktop: isDesktopViewport } = useMediaQueryHelper()
  const isEnabled = useTogglesStore((state) => state.toggles?.[toggleKey])

  const isDesktop = isEnabled === true && isDesktopViewport

  return { isDesktop }
}
